import React from 'react';
import swal from 'sweetalert';
import Tooltip from 'react-tooltip-lite';
import I18n from '../locales/i18n';

const DeleteMessage = (props) => {
	const onClick = (e) => {
		swal({
			title: '',
			text: 'Se eliminará este mensaje, ¿Estas seguro?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				props.onClick(props.postIdx, props.idx);
			}
		});
	};
	if (props.isOwner) {
		return (
			<Tooltip content={I18n('CHAT', 'DELETE_ITEM')} direction="bottom">
				<button
					onClick={onClick}
					className="deleteIcon"
					disabled={props.deleteLoading}
				>
					<i className="fas fa-trash-alt"></i>
				</button>
			</Tooltip>
		);
	}
	return null;
};

export default DeleteMessage;
